<template>
  <!--2 colonnes : dossier theme / collapse theme&video-->
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-4 col-md-4">
        <h3>{{ $t("common.list") }}</h3>
        <div class="d-flex align-items-center">
          <v-treeview
            :active="[themeSelected]"
            :items="themes"
            activatable
            hoverable
            dense
            return-object
            open-on-click
            item-text="title"
            @update:active="themeSelection"
            class="col-xl-12 pl-0"
          >
          </v-treeview>
        </div>
      </div>
      <div class="col-xl-8 col-md-8">
        <template v-if="themeSelected === null">
          <h3 class="text-center mb-4">{{ $t("theme.text") }}</h3>
          <div class="gif-hide">
            <img
              class="dropShadow"
              style="width: 100%"
              src="/media/svg/illustrations/TMG-Gif-SujetsAbordes.gif"
            />
          </div>
          <v-row class="pt-10 pb-10 d-flex justify-content-center">
            <div class="d-flex flex-column justify-content-center">
              <p style="color: #3b3838; text-align: center; line-height: 0.5em">
                {{ $t("wish.noSatifyingResultTheme") }}
              </p>
              <FormWish
                mode="Theme_NoSatifyingResult"
                search=""
                searchResultNumber=""
                video="-1"
                theme="-1"
              />
            </div>
          </v-row>
        </template>
        <template v-else>
          <div>
            <h3 class="text-center mb-4">
              {{ themeSelected.title }}
            </h3>

            <div
              v-if="
                typeof themeSelected.children === 'undefined' ||
                themeSelected.children.length === 0
              "
            >
              <!--panel theme/video-->
              <div class="row my-2" style="justify-content:space-between;">
                <h5 class="mb-0" style="align-self:center">
                  {{ $tc("theme.subTitle", themeSelected.videos.length) }}
                </h5>
                 <!-- Gestion de l'ordre -->
                <SortingMenu class="mx-2" @sortingParameters="getSorting" />
              </div>
              <div v-if="themeSelected.videos.length > 0">
                <div class="v-cards-theme v-cards-theme--small">
                  <div v-for="video in themeSelected.videos" :key="video.id">
                    <VideoThemeCard
                      v-bind:video="video"
                      v-bind:theme="themeSelected"
                    >
                    </VideoThemeCard>
                  </div>
                </div>
              </div>

              <!--Si aucune video à afficher-->
              <div v-else>
                <p>{{ $t("theme.text2") }}</p>
              </div>
              <v-row class="pt-10 pb-10 d-flex justify-content-center">
                <div class="d-flex flex-column justify-content-center">
                  <p
                    style="
                      color: #3b3838;
                      text-align: center;
                      line-height: 0.5em;
                    "
                  >
                    {{ $t("wish.noSatifyingResultTheme") }}
                  </p>
                  <FormWish
                    mode="Theme_NoSatifyingResult"
                    search=""
                    searchResultNumber=""
                    video="-1"
                    :theme="themeSelected ? themeSelected.id.toString() : '-1'"
                  />
                </div>
              </v-row>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
@media only screen and (max-width: 721px) {
  .gif-hide {
    display: none !important;
  }
}
/* .dropShadow{
    filter: drop-shadow(5px 5px 5px #a1a1a1);
  } */
.dropShadow {
  box-shadow: 5px 5px 5px #a1a1a1;
}
</style>

<script>
import Api from "@/core/services/api.service";
import VideoThemeCard from "@/components/video/videoThemeCard";
import userParentThemes from "@/core/utils/userParentThemes";
import store from "@/core/services/store";
import FormWish from "@/components/common/formWish";
import SortingMenu from "@/components/common/sortingMenu";

export default {
  name: "themesUser",
  components: { VideoThemeCard, FormWish, SortingMenu },
  data: () => ({
    themes: [],
    themeSelected: null,
    sortingParameters: null,
  }),
  mounted() {
    Api.get("themes").then(
      (themes) => (this.themes = userParentThemes(themes.data["hydra:member"]))
    );
  },
  methods: {
    getSorting(sortingParameters) {
      this.sortingParameters = sortingParameters;
      this.filterAndSortThemeVideo(this.themeSelected);
    },
    filterAndSortThemeVideo(theme) {
      if (theme && theme.videos) {
        // TODO !! Mécanisme historique TMG ==> à changer coté backend ? !! 
        // Opération de filtre admin - Ne pas afficher les vidéos non visibles si l'utilisateur n'est pas administrateur
        if (!store.getters.isAdmin) {
          theme.videos = theme.videos.filter((v) => v.isVisible);
        }

        // Opération de tri des vidéos 
        let orderType =  this.sortingParameters!= null && this.sortingParameters.sortVideoType >= 0 ? this.sortingParameters.sortVideoTypeList[this.sortingParameters.sortVideoType].type : "sort-date";
        let orderDirection = this.sortingParameters!= null && this.sortingParameters.sortVideoDirection >= 0 ? this.sortingParameters.sortVideoDirectionList[this.sortingParameters.sortVideoDirection].direction : "ASC";
        let sortThemeProperty = null;
        let sortThemePropertyNumeric = false;
        let sortOrder = 1;
        switch (orderType) {
          case "sort-date":
            sortThemeProperty = "createdAt";
            break;
          case "sort-alpha":
            sortThemeProperty = "title";
            break;
          case "sort-view":
            sortThemeProperty = "totalViews";
            sortThemePropertyNumeric = true;
            break;
        }
        if(orderDirection == "DESC"){
          sortOrder = -1;
        }

        // Sortie si aucun ordre défini
        if(sortThemeProperty == null){
          return;
        }
        theme.videos.sort((a, b) => {
          let aCast = sortThemePropertyNumeric ? parseInt(a[sortThemeProperty]) : a[sortThemeProperty];
          let bCast = sortThemePropertyNumeric ? parseInt(b[sortThemeProperty]) : b[sortThemeProperty];
          let result = aCast > bCast ? 1 : bCast > aCast ? -1 : 0;
          return result * sortOrder;
        });
      }
    },
    themeSelection(themes) {
      let theme = themes[0] ?? null;
      this.filterAndSortThemeVideo(theme);
      this.themeSelected = theme;
    },
  },
};
</script>
